import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import MyCoursesComp from './MyCoursesComp'

function MyCourses() {
  return (
    <div className='mainContainer'>
      <LeftmenuIn />
      <div className='theMainContainer'>
        <DashnavIn />
        <MyCoursesComp />
      </div>
    </div>
  )
}

export default MyCourses
